import { LinkButton } from "./ui/Button";
import { useLocation } from "react-router-dom";
import { useMenu } from "../contexts/MenuContext";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/modules/users/selector";
import { NavItemsType, NavItemType } from "src/layouts/DashboardLayout";

export function NavSection({
  links = [],
  mini = false,
  active,
}: {
  links: NavItemsType;
  mini?: boolean;
  active?: NavItemType;
}) {
  const { pathname } = useLocation();
  const { closeMenu } = useMenu();
  const currentUser = useAppSelector(selectCurrentUser);
  const { isAdmin, isFactoryAdmin } = currentUser;

  return (
    <div className="flex flex-row py-[15px] w-full justify-left">
      <div className={"flex flex-col grow"}>
        {links.map((n, index) => {
          // if (n.name === "Настройки" && !(isFactoryAdmin || isAdmin)) return null;
          if (n.name === "Отчеты")
            return (
              <LinkButton
                key={index}
                to={n.url}
                text={n.name}
                icon={n.icon}
                mini={mini}
                active={pathname.includes(n.url)}
                onClick={closeMenu}
              />
            );
          // логика для gos "Главная" - активна на главной странице и всех подстраницах,
          if (n.name === "Главная" && !pathname.includes('change-approvers'))
            return (
              <LinkButton
                key={index}
                to={n.url}
                text={n.name}
                icon={n.icon}
                mini={mini}
                active={pathname === n.url || (pathname.startsWith(n.url + "/") && !links.slice(1).some(link => pathname.startsWith(link.url)))}
                onClick={closeMenu}
              />
            );
          return (
            <LinkButton
              key={index}
              to={n.url}
              text={n.name}
              icon={n.icon}
              mini={mini}
              active={pathname === n.url || (n.name === 'Документы' && pathname.includes('change-approvers') || (n.name === 'Настройки' && pathname.includes('triggers')))}
              onClick={closeMenu}
            />
          );
        })}
      </div>
    </div>
  );
}
